import { twMerge } from 'tailwind-merge';

import type { DetailBoxProps } from './DetailBox.types';

const VARIANT_CLASSES = {
  solid: 'border-transparent bg-surface',
  outlined: 'border-border',
} as const;

export function DetailBox({ variant = 'solid', className, children }: DetailBoxProps) {
  return (
    <div className={twMerge(`rounded-2xl border p-6 ${VARIANT_CLASSES[variant]}`, className)}>
      {children}
    </div>
  );
}
